import { getOwaLazyErrorConfig } from 'mini-error-handler/lib/utils/getOwaLazyErrorConfig';
import { LazyModule } from 'owa-bundling';
import { withSilentErrorHandler } from 'mini-error-handler/lib/components/withSilentErrorHandler';

const lazyModule = new LazyModule(
    () =>
        import(
            /* webpackChunkName: "MiniMailModuleCampaigns", webpackPreload: true */ './lazyIndex'
        )
);

export const LazyMiniMailCampaignSurface = withSilentErrorHandler(
    null,
    getOwaLazyErrorConfig(lazyModule, m => m.MiniMailCampaignSurface)
);
export const LazyMiniPushNotificationsSurface = withSilentErrorHandler(
    null,
    getOwaLazyErrorConfig(lazyModule, m => m.MiniPushNotificationsSurface)
);
